import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetBatch(id: string | undefined) {
  return useQuery(queries.stocks.getBatchById(id || ''))
}
